// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"75e692ec","39":"37c66a16","167":"c450e809","188":"3197e323","691":"74d95259","787":"bd15ee5d"}[chunkId] + ".chunk.js";
};